export const BENEFIT_TYPES: Array<{ value: string; label: string; color: string; icon: string }> = [
    { value: 'general', label: 'כללי', color: 'cyan', icon: '🌐' },
    { value: 'food', label: 'אוכל', color: 'orange', icon: '🍔' },
    { value: 'entertainment', label: 'בידור', color: 'purple', icon: '🎬' },
    { value: 'clothes', label: 'ביגוד', color: 'blue', icon: '👗' },
    { value: 'cosmetics', label: 'קוסמטיקה', color: 'magenta', icon: '💄' }
]

export const ACTION_TYPES: Array<{ value: string; label: string; color: string; icon: string }> = [
    { value: 'link', label: 'קישור', color: 'geekblue', icon: '🔗' },
    { value: 'coupon', label: 'קופון', color: 'green', icon: '🏷️' },
    { value: 'api', label: 'API', color: 'volcano', icon: '⚡' }
]
